import { gunterzBold } from '@/theme/fonts';
import { Flex, NumberFormatter, Space, Text, rem } from '@mantine/core';
import type { BunkerRewardItemType } from './data';
export const BunkerRewardSuccessItem: React.FC<BunkerRewardItemType> = ({
  percent,
  exp,
  multiplier,
  topDes,
  bottomDes
}) => {
  return <Flex gap={4} justify="space-between" bd="1px solid var(--icon-primary)" p={10} style={{
    borderRadius: 5
  }} direction="column">
      <Flex>
        <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
          {topDes}
        </Text>
        <Space w={4} />
        <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
          {bottomDes}
        </Text>
      </Flex>

      <Text c="var(--text-white)" className={gunterzBold.className} fz={{
      base: 14,
      sm: 18
    }} lh={{
      base: rem(16),
      sm: rem(20)
    }}>
        <NumberFormatter value={percent || exp || multiplier} suffix={percent ? '%' : multiplier ? 'X' : 'XP'} />
      </Text>
    </Flex>;
};